import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { seoMetadataFor, seoPageFor, SITE_ORIGIN, SITE_NAME } from "@/data/seoMetadata";

const setMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) { element = document.createElement("meta"); element.setAttribute(attribute, key); document.head.appendChild(element); }
  element.setAttribute("data-seo", ""); element.setAttribute("content", content);
};

// Route metadata is centralized in data/seoPages.js so initial HTML and SPA navigation agree.
// Existing page-level <Seo> declarations remain compatible; the shared catalogue is authoritative.
export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = seoMetadataFor(seoPageFor(pathname));
    document.title = meta.title;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.setAttribute("data-seo", ""); canonical.href = meta.url;
    setMeta("name", "description", meta.description);
    setMeta("name", "robots", window.location.origin !== SITE_ORIGIN ? "noindex, nofollow" : meta.robots);
    Object.entries({ type: meta.type || "website", url: meta.url, title: meta.title, description: meta.description, site_name: SITE_NAME, image: meta.image, "image:alt": meta.imageAlt, locale: "en_US" }).forEach(([key, value]) => setMeta("property", `og:${key}`, value));
    Object.entries({ card: meta.image.endsWith("/emblem-512.png") ? "summary" : "summary_large_image", url: meta.url, title: meta.title, description: meta.description, image: meta.image, "image:alt": meta.imageAlt }).forEach(([key, value]) => setMeta("name", `twitter:${key}`, value));
    let jsonLd = document.head.querySelector('script[data-seo][type="application/ld+json"]');
    if (!jsonLd) { jsonLd = document.createElement("script"); jsonLd.type = "application/ld+json"; jsonLd.setAttribute("data-seo", ""); document.head.appendChild(jsonLd); }
    jsonLd.textContent = JSON.stringify(meta.jsonLd).replace(/</g, "\\u003c");
  }, [pathname]);
  return null;
}